import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment-timezone';

import { Row, Col } from 'antd';

import AppStore from 'stores/App';
import ShopStore from 'stores/ShopStore';
import AppointmentStore from 'stores/AppointmentStore';
import CurrentUserStore from 'stores/CurrentUserStore';
import AppointmentPreviewSection from 'containers/CreateAppointment/AppointmentPreviewSection';
import { PitstopButton } from 'shared';

const ButtonArea = styled.div`
  display: flex;
  button:nth-child(2) {
    margin-left: auto;
  }
  margin: 10px 0px;
`;

class ShareVehicleHealthReportPage extends Component {
  state = {
    loading: false,
  };

  setValue = (name, value, callback = () => {}) => {
    if (name === 'vehicle') {
      this.setState({ selectedCarId: value }, callback);
    } else if (name === 'assignedTo') {
      this.setState({ assignedTo: value }, callback);
    } else if (name === 'description') {
      this.setState({ description: value }, callback);
    } else {
      this.setState({ [name]: value }, callback);
    }
  };

  setChildCallables = (callables) => {
    this.childCallables = callables;
    if (this.props.setParentCallables) {
      this.props.setParentCallables(callables);
    }
  };

  share = async () => {
    let { description, assignedTo } = this.state;

    const values = await this.childCallables.handleSubmit();
    const selectedCarId = values.vehicle || this.props.selectedCarId;

    const shopId = ShopStore.currentShop?.id || CurrentUserStore.user?.shopId;
    await this.childCallables.handleSubmit();

    this.setState({ loading: true });

    for (const contacts of assignedTo) {
      const parsedContacts = JSON.parse(contacts);

      var appointmentObject = {
        carId: selectedCarId,
        userId: CurrentUserStore.user.id,
        comments: description,
        appointmentDetails: {
          state: 'reminder',
          startTime: moment().toISOString(),
          endTime: moment().add(1, 'hour').toISOString(),
          timezone: CurrentUserStore.user.settings.timezone,
        },
        existingUser: true,
        contactId: parsedContacts.id,
        source: parsedContacts.source,
      };

      try {
        await AppointmentStore.sendReportToContact(shopId, appointmentObject);

        // close the modal
        AppStore.openModals.set('SHARE_VEHICLE_HEALTH_REPORT_MODAL', false);
        AppStore.addSuccess('Report shared');
      } catch (err) {
        console.log('Error in sending report to contact', err);
        AppStore.addError('Sorry! We are unable to share with the contact(s)!');
      } finally {
        this.setState({ loading: false });
      }
    }

    return;
  };

  render() {
    return (
      <Row>
        <Col span={24}>
          <h1>Share Vehicle Health Report</h1>
        </Col>
        <Col span={24}>
          <AppointmentPreviewSection
            setCallables={this.setChildCallables}
            key="appointmentPreview"
            showAppointmentTime={false}
            selectedCarId={this.props.selectedCarId}
            description={''}
            setValue={this.setValue}
          />
        </Col>
        <Col span={24}>
          <ButtonArea>
            <PitstopButton
              loading={this.state.loading}
              disabled={this.isDisabled}
              type="primary"
              onClick={() => this.share()}
            >
              Share
            </PitstopButton>
          </ButtonArea>
        </Col>
      </Row>
    );
  }
}

ShareVehicleHealthReportPage.propTypes = {
  selectedCarId: PropTypes.number,
};

export default withRouter(observer(ShareVehicleHealthReportPage));
